'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$25() {
  this.bgf = null;
  this.bgd = null;
  this.bge = false;
  this.bgb = null;
  this.bgc = false;
  this.bgg = false;
  this.bgh = false;
  this.bgf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$25 as $c_Lpresto_PrestoRouter$$anon$25 };
$p = $c_Lpresto_PrestoRouter$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$25;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$25() {
}
export { $h_Lpresto_PrestoRouter$$anon$25 as $h_Lpresto_PrestoRouter$$anon$25 };
$h_Lpresto_PrestoRouter$$anon$25.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgf;
});
$p.t = (function() {
  if ((!this.bge)) {
    this.bgd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bge = true;
  }
  return this.bgd;
});
$p.ae = (function() {
  if ((!this.bgc)) {
    this.bgb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgc = true;
  }
  return this.bgb;
});
$p.w = (function() {
  if ((!this.bgh)) {
    this.bgg = false;
    this.bgh = true;
  }
  return this.bgg;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$25, "presto.PrestoRouter$$anon$25", ({
  NQ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$25 as $d_Lpresto_PrestoRouter$$anon$25 };
//# sourceMappingURL=presto.-Presto-Router$$anon$25.js.map
